(function () {
	'use strict';

	angular.module('mx.SolutionBuilderAgent').component('mxObjectImage', {
		require: { mxFormCtrl: '?^mxForm' },
		bindings: {
			objectId: '=?',
			objectIds: '=?',
			entity: '@',
			ngModel: '@',
			lazyMode: '=?',
			readOnly: '=?',
			files: '=?',
			getSelectedObjects: '=?',
			enableSelection: '@',
			skipInitialLoad: '=?',
			width: '@?',
			height: '@?',
			maxWidth: '@?',
			maxHeight: '@?',
			src: '=?',
			default: '@?',
			onAttachmentDelete: '&',
		},
		controller: MxObjectImageCtrl,
		controllerAs: 'vm',
		templateUrl: 'workspaces/SolutionBuilderAgent/components/mx-object-image/mx-object-image.html',
	});

	MxObjectImageCtrl.$inject = [
		'$q',
		'$scope',
		'$element',
		'mx.shell.HostUrlHelper',
		'mx.sb.Attachment.MxAttachmentService',
		'mx.internationalization',
		'mx.shell.NotificationService',
	];

	function MxObjectImageCtrl($q, $scope, $element, hostHelper, attachmentService, i18n, notificationService) {
		const vm = this;

		vm.$onInit = function () {
			vm.files = [];
			vm.bindAttribute = vm.ngModel;
			vm.formatUrl = formatUrl;
			vm.onDelete = onDelete;
			vm.uploadFile = uploadFile;
			vm.waithandler = $q.defer();
			vm.ignoreFileLimitations = true;
			vm.onGetFileUrl = onGetFileUrl;

			initProviderSettings().then(() => {
				const loadPromise = vm.skipInitialLoad === true || vm.objectId === 'new' ? Promise.resolve([]) : loadFiles(vm.objectId);
				loadPromise.then(function (files) {
					vm.files = (files || []).filter((file) => vm.src?.includes(file.id));
					if (!vm.files.length && vm.src) {
						vm.files.push(getVirtualFileFromSrc(vm.src));
					}
				});
			});
		};

		function getVirtualFileFromSrc(src) {
			let srcTmp = src.replace(/"/g, '');
			let fileName = '';

			const isBase64 = src.includes('data:image');

			if (!isBase64) {
				fileName = srcTmp.substring(srcTmp.lastIndexOf('/') + 1);
				srcTmp = hostHelper.getFullImageUrl(srcTmp);
			}

			const img = {
				name: fileName,
				url: srcTmp,
				size: null,
				thumbnail: null,
				uploadedOn: null,
				isVirtual: true,
				uploaded: true,
			};
			return !isBase64 && mx.components.Utils.isGuid(fileName)
				? Object.assign(img, {
						id: fileName,
						providerId: vm.storageInfo.providerId,
				  })
				: img;
		}

		vm.$postLink = function () {
			if ((vm.objectId === undefined || vm.objectId === '') && vm.mxFormCtrl) {
				vm.objectId = vm.mxFormCtrl.objectId;
			}

			if (!vm.objectIds) {
				vm.objectIds = [];
			}

			if (vm.objectId !== undefined && vm.objectId !== '') {
				if (vm.objectIds.length === 0) {
					vm.objectIds.push(vm.objectId);
				}
				vm.waithandler.resolve();
			} else {
				vm.waithandler.reject();
			}

			$element[0].addEventListener('drop', onDrop, true);

			$scope.$on('$destroy', function cleanUp() {
				$element[0].removeEventListener('drop', onDrop);
			});
		};

		vm.getSelectedObjects = function () {
			return vm.files
				.filter(function (file) {
					return file.selected;
				})
				.map(function (file) {
					return {
						Id: file.id,
						DisplayString: file.name,
					};
				});
		};

		return vm;

		async function uploadFile(file) {
			const attachmentInfo = Object.assign(file, {
				id: mx.components.Utils.guid(),
				objectId: vm.objectId,
				providerId: vm.storageInfo.providerId,
				storageId: vm.storageInfo.id,
				typeId: vm.storageInfo.typeId,
				isPublic: vm.storageInfo.isPublic,
				bindAttribute: vm.bindAttribute,
			});
			try {
				await attachmentService.uploadFile(attachmentInfo);
				vm.src = `api/filestorage/${attachmentInfo.id}`;
			} catch (e) {
				console.error(e.message);
				notificationService.error(i18n.getFormatted('components.mx-attachments.upload_file_error', file.name));
			}
		}

		async function loadFiles(objectId) {
			return await attachmentService.getFiles({
				objectIds: objectId && [objectId],
				bindAttribute: vm.bindAttribute,
			});
		}

		async function onGetFileUrl(file) {
			return await attachmentService.getFileUrl(file);
		}

		function formatUrl(url) {
			const isBase64 = url.includes('data:image');
			return isBase64 ? url : attachmentService.formatFileUrl(url);
		}

		async function onDelete(file) {
			if (!file.isVirtual) {
				await attachmentService.deleteFiles([file]);
			}
			vm.src = null;
			const index = vm.files.indexOf(file);
			if (index > -1) {
				vm.files.splice(index, 1);
			}
			vm.onAttachmentDelete({ file });
		}

		function onDrop(e) {
			if (!e.dataTransfer.files[0].type.match(/image.*/)) {
				e.stopPropagation();
				e.preventDefault();
				return;
			}

			if (vm.files.length) {
				vm.onDelete(vm.files[0]);
			}
		}

		async function initProviderSettings() {
			vm.storageInfo = await attachmentService.getStorageInfo(vm.entity);
		}
	}
})();
